import { supabase } from "./supabase";
import { validateUserData } from "../utils/validation";

export interface UserInfo {
  email: string;
  first_name: string;
  last_name: string;
  job_title?: string;
  employer_name?: string;
  marketing_consent?: boolean;
}

export const upsertUser = async (info: UserInfo) => {
  try {
    // Validate user data
    const validation = validateUserData({
      firstName: info.first_name,
      lastName: info.last_name,
      email: info.email,
      jobTitle: info.job_title,
      employerName: info.employer_name
    });

    if (!validation.isValid) {
      throw new Error(`Invalid user data: ${Object.values(validation.errors).join(', ')}`);
    }

    console.log('Upserting user:', info.email);
    
    const { data, error } = await supabase
      .from("users")
      .upsert(
        {
          email: info.email,
          first_name: info.first_name,
          last_name: info.last_name,
          job_title: info.job_title,
          employer_name: info.employer_name,
          marketing_consent: info.marketing_consent,
          language: 'es',
          updated_at: new Date().toISOString()
        },
        {
          onConflict: 'email',
          ignoreDuplicates: false
        }
      )
      .select()
      .single();

    if (error) {
      console.error('Error upserting user:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error in upsertUser:', error);
    throw error;
  }
};